import axios from 'axios'
import Vue from 'vue'
// import { Toast } from 'vant'
// import store from '@/store/index'
// import { generateUUID } from '@/utils/common'
import { getFingerprint } from '@/utils/common'
import { isNeedLogin } from '@/components/loginFlow'
import { resolveApiBaseURL } from '@/utils/runtimeConfig'
import { countryRoutePath } from '@/router/routeGuardHelpers'
import { safeGetStorageItem, safeLocalStorage, safeRemoveStorageItem } from '@/utils/safeStorage'

import router from '../router' // 引入路由
const envApiBaseURL =
  typeof process !== 'undefined' && process.env
    ? process.env.VUE_APP_H5_API_BASE_URL
    : ''

function browserWindow() {
  try {
    return typeof window !== 'undefined' && window ? window : null
  } catch (e) {
    return null
  }
}

function browserOrigin() {
  try {
    const win = browserWindow()
    const location = win && win.location
    const origin = location && location.origin
    return origin ? origin : ''
  } catch (e) {
    return ''
  }
}

function getFingerprintValue() {
  try {
    const win = browserWindow()
    return win && win.fingerprint ? win.fingerprint : ''
  } catch (e) {
    return ''
  }
}

function setFingerprintValue(value) {
  try {
    const win = browserWindow()
    if (win) {
      win.fingerprint = value || ''
      return win.fingerprint
    }
  } catch (e) {
    return value || ''
  }
  return value || ''
}

// 创建 axios 实例，将来对创建出来的实例，进行自定义配置
// 好处：不会污染原始的 axios 实例
const instance = axios.create({
  // 基地址: devServer proxies /a to local ashe; env override stays available for local debugging.
  baseURL: resolveApiBaseURL(browserOrigin(), envApiBaseURL),
  // baseURL: 'https://vukavi.com/a/',
  //   超时时间
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json' // 默认请求头
  },
  params: {
    lang: safeGetStorageItem(safeLocalStorage(), 'defaultLanguage', 'en')
  },
  transformRequest: [
    (data, headers) => {
      // 检测是否为 POST 请求
      if (headers['Content-Type'] === 'application/json') {
        // 获取指纹（异步操作）
        // 添加固定参数
        data = {
          mode: 2, // 固定模式
          code: 2,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, //客户端时区
          platform: safeGetStorageItem(safeLocalStorage(), 'platform', 'Otbet'), //平台名称(单国默认科特迪瓦 Otbet)
          uuid: getFingerprintValue(), // 客户端的uuid ，网页端要自己生成
          online: true, //是否在线
          currency: safeGetStorageItem(safeLocalStorage(), 'currency', 'XOF'), //币种(单国默认科特迪瓦 XOF)
          isWap: true, //是否手机端
          ...data // 合并用户传入的数据
        }
      }
      return JSON.stringify(data) // 返回 JSON 格式的请求体
    }
  ]
})

// 自定义配置  -- 请求/响应 拦截器
// 添加请求拦截器

// 请求拦截器
instance.interceptors.request.use(
  async (config) => {
    // 开启loading，禁止背景点击(节流处理，多次点击无效)
    // Toast.loading({
    //   message: '加载中...',
    //   forbidClick: true, // 是否禁止背景点击
    //   loadingType: 'spinner',
    //   duration: 0 // 展示时长(ms)，值为 0 时，toast 不会消失
    // })
    // 如果指纹尚未获取，调用 getFingerprint 方法
    if (!getFingerprintValue()) {
      setFingerprintValue(await getFingerprint())
    }
    // // 在这里可以对请求头进行统一配置，例如添加认证token
    const storage = safeLocalStorage()
    const token = safeGetStorageItem(storage, 'token') // 假设token存储在localStorage中
    if (token) {
      config.headers['X-Access-Token'] = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    if (isNeedLogin(response.data)) {
      const storage = safeLocalStorage()
      safeRemoveStorageItem(storage, 'token')
      const currentPath = router.currentRoute && router.currentRoute.path
      // 停留在当前页直接弹登录的场景：activity、home
      const stayInPlace =
        currentPath && (currentPath.includes('/activity') || currentPath.includes('/home'))
      if (stayInPlace) {
        // 通过全局事件总线触发登录弹窗（layout/index.vue 监听）
        if (Vue.prototype.$bus) Vue.prototype.$bus.$emit('openLogin')
      } else {
        router
          .push(countryRoutePath(safeGetStorageItem(storage, 'country'), 'home'))
          .catch((err) => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
      }
    }
    return response.data // 直接返回响应数据
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 导出配置好的实例
export default instance
